import MainHome from './MainHome.svelte';

const app = new MainHome({
	target: document.body,
});

export default app;
